import { InvalidStateError } from '@/common/errors';
import { getCurrentTimestamp } from '@/common/utils';
import { BuildSlice } from '@/types/stores/build';
import { PlanSlice } from '@/types/stores/plan';
import { PlannerSlice } from '@/types/stores/planner';
import { ProjectSlice } from '@/types/stores/project';
import { RootActions } from '@/types/stores/rootActions';
import { WritableDraft } from 'immer';

export function updateProjectModified(
  state: WritableDraft<BuildSlice & PlanSlice & PlannerSlice & ProjectSlice & RootActions>,
  isSystem?: boolean,
) {
  if (isSystem) {
    state.project.data.airchefValues.datesAndAudit.modifiedAtBySystem = getCurrentTimestamp();
  } else {
    state.project.data.airchefValues.datesAndAudit.modifiedAt = getCurrentTimestamp();
    state.project.data.airchefValues.datesAndAudit.modifiedBy = state.planner.user.data?.userPrincipalName ?? '';
  }
}

export function updateAssetModified<
  T extends { airchefValues: { datesAndAudit: { modifiedBy?: string | null; modifiedAt?: string | null } } },
>(asset: WritableDraft<T>, state: WritableDraft<BuildSlice & PlanSlice & PlannerSlice & ProjectSlice & RootActions>) {
  const now = getCurrentTimestamp();
  const user = state.planner.user.data?.userPrincipalName ?? '';

  asset.airchefValues.datesAndAudit.modifiedAt = now;
  asset.airchefValues.datesAndAudit.modifiedBy = user;
}

export function getVersionFromSchema(schema: string): `v${string}` {
  if (!schema || typeof schema !== 'string' || !schema.startsWith('/schemas/'))
    throw new InvalidStateError('Not a valid schema string');

  const [, , ver] = schema.split('/');

  return ver as `v${string}`;
}

export function updateAssetModifiedPlain<
  T extends {
    airchefValues: {
      datesAndAudit: {
        modifiedBy?: string | null;
        modifiedAt?: string | null;
        createdAt: string;
        author?: string | null;
      };
    };
  },
>(asset: T, now: string, user: string, updateCreated?: boolean) {
  asset.airchefValues.datesAndAudit.modifiedAt = now;
  asset.airchefValues.datesAndAudit.modifiedBy = user;
  if (updateCreated) {
    asset.airchefValues.datesAndAudit.author = user;
    asset.airchefValues.datesAndAudit.createdAt = now;
  }
}
